// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aulgyacwocpazwdldmzu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1bGd5YWN3b2NwYXp3ZGxkbXp1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwOTU1MDgsImV4cCI6MjA1ODY3MTUwOH0.XZfHtZOyfsGw2faPSdrhNxFbBNBfViva8MWyvKUt25Y";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);